import React from 'react';
import { Typography } from '@mui/material';
import WhatsAppFormattedText from '../WhatsAppFormattedText';

const MessageSenderLabel = ({ message }) => {
  if (!message.senderName || !message.isSent || message.pending) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      component="div"
      sx={(theme) => ({
        display: 'block',
        mb: 0.3,
        // Só aparece em mensagem enviada (balão primarySoft).
        color: theme.alpha((theme.vars || theme).palette.primarySoft.contrastText, 0.95),
      })}
    >
      <WhatsAppFormattedText text={message.senderName} />
    </Typography>
  );
};

export default MessageSenderLabel;
